<template>
  <Flex>
    <BaseLabel
      v-if="hasActiveVenue"
      color="success"
    >
      {{ $t('admin.treatwell.status.enabled') }}
    </BaseLabel>
    <BaseLabel
      v-else
      color="warning"
    >
      {{ $t('admin.treatwell.status.in_progress') }}
    </BaseLabel>
    <BaseLabel
      v-if="treatwellStatus.freeCommissionRemainingDays"
      :color="treatwellStatus.contractSigned ? 'success' : 'warning'"
      v-test="'tw-trial-status'"
    >
      {{ treatwellStatus.contractSigned
          ? $t('admin.treatwell.status.benefits_remaining', {
              days: treatwellStatus.freeCommissionRemainingDays
            })
          : $t('admin.treatwell.status.trial_remaining', {
              days: treatwellStatus.freeCommissionRemainingDays
            }) }}
    </BaseLabel>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { useTreatwellStore } from '@/stores/treatwell';

// Whether the integration is live, and how many free days are left
const { treatwellStatus, hasActiveVenue } = storeToRefs(useTreatwellStore());
</script>
